// extracted by mini-css-extract-plugin
module.exports = {"logo_container":"Logo_logo_container__2qux2"};